import React from 'react';
import { FaPython, FaReact, FaMicrosoft, FaAws } from "react-icons/fa";
import { SiPrisma } from "react-icons/si";
import { PiFileSql } from "react-icons/pi";
import { VscAzure } from "react-icons/vsc";
import { SiPytorch } from "react-icons/si";
import { SiTensorflow } from "react-icons/si";
import LLogo from '../assets/L_logo.svg';


function Footer() {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-[#0a0a16] border-t border-gray-800 pt-16 pb-8">
            <div className="max-w-[1200px] mx-auto px-6">
                {/* Main footer content */}
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
                    {/* Brand column */}
                    <div className="md:col-span-1">
                        <div className="flex items-center mb-4">
                            <div className="w-10 h-10 bg-gradient-to-br from-indigo-500 to-blue-600 rounded-lg mr-3 flex items-center justify-center">
                                <img src={LLogo} alt='Laminar logo' className='w-full h-full object-contain' />
                            </div>
                            <div>
                                <h3 className="text-xl font-bold text-white">
                                    LAMINAR<span className="text-indigo-400"> INNOVATION</span>
                                </h3>
                            </div>
                        </div>
                        <p className="text-gray-400 text-sm mb-6">
                            Transforming business processes from turbulent to laminar with innovative software solutions.
                        </p>
                    </div>

                    {/* Links columns */}
                    <div>
                        <h4 className="text-white font-semibold mb-4">Company</h4>
                        <ul className="space-y-2">
                            <li><a href="#about" className="text-gray-400 hover:text-indigo-400 text-sm transition-colors">About</a></li>
                            <li><a href="#process" className="text-gray-400 hover:text-indigo-400 text-sm transition-colors">Our Process</a></li>
                            <li><a href="#contact" className="text-gray-400 hover:text-indigo-400 text-sm transition-colors">Contact</a></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-white font-semibold mb-4">Services</h4>
                        <ul className="space-y-2">
                            <li><button className="text-gray-400 hover:text-indigo-400 text-sm transition-colors text-left bg-transparent border-none cursor-pointer">Artificial Intelligence</button></li>
                            <li><button className="text-gray-400 hover:text-indigo-400 text-sm transition-colors text-left bg-transparent border-none cursor-pointer">Machine Learning</button></li>
                            <li><button className="text-gray-400 hover:text-indigo-400 text-sm transition-colors text-left bg-transparent border-none cursor-pointer">Web Development</button></li>
                            <li><button className="text-gray-400 hover:text-indigo-400 text-sm transition-colors text-left bg-transparent border-none cursor-pointer">Process Automation</button></li>
                            <li><button className="text-gray-400 hover:text-indigo-400 text-sm transition-colors text-left bg-transparent border-none cursor-pointer">Consulting</button></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-white font-semibold mb-4">Contact</h4>
                        <ul className="space-y-2">
                            <li><a href="mailto:contact@laminarinnovation.com" className="text-gray-400 hover:text-indigo-400 text-sm transition-colors">contact@laminarinnovation.com</a></li>
                        </ul>
                    </div>
                </div>

                {/* Technologies */}
                <div className="py-8 border-t border-gray-800">
                    <h4 className="text-center text-gray-300 text-sm mb-6">Technologies We Work With</h4>
                    <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12">
                        <div className="tech-icon group">
                            <FaPython size={24} className="text-gray-500 group-hover:text-indigo-400 transition-colors" />
                        </div>
                        <div className="tech-icon group">
                            <FaReact size={24} className="text-gray-500 group-hover:text-indigo-400 transition-colors" />
                        </div>
                        <div className="tech-icon group">
                            <FaMicrosoft size={24} className="text-gray-500 group-hover:text-indigo-400 transition-colors" />
                        </div>
                        <div className="tech-icon group">
                            <FaAws size={24} className="text-gray-500 group-hover:text-indigo-400 transition-colors" />
                        </div>
                        <div className="tech-icon group">
                            <SiPrisma size={24} className="text-gray-500 group-hover:text-indigo-400 transition-colors" />
                        </div>
                        <div className="tech-icon group">
                            <PiFileSql size={24} className="text-gray-500 group-hover:text-indigo-400 transition-colors" />
                        </div>
                        <div className="tech-icon group">
                            <VscAzure size={24} className="text-gray-500 group-hover:text-indigo-400 transition-colors" />
                        </div>
                        <div className="tech-icon group">
                            <SiPytorch size={24} className="text-gray-500 group-hover:text-indigo-400 transition-colors" />
                        </div>
                        <div className="tech-icon group">
                            <SiTensorflow size={24} className="text-gray-500 group-hover:text-indigo-400 transition-colors" />
                        </div>
                    </div>
                </div>

                {/* Copyright */}
                <div className="pt-8 border-t border-gray-800 text-center">
                    <p className="text-gray-500 text-sm">&copy; {currentYear} Laminar Innovation. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;